import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Schoolbusonrentinpune() {



const cardData =
{
  keyword: 'School Bus on Rent in Pune',
  heading: 'Sanavi Travels: School Bus on Rent in Pune',
  headingDescription: 'Sanavi Travels provides safe, reliable, and well-managed school bus rental services in Pune, designed to support schools, colleges, institutions, parents, and organizations for student transportation, educational tours, picnics, and outstation travel with complete peace of mind.',

  top: 'Top Uses of School Bus on Rent in Pune',

  topPlaces: [
    {
      title: 'Daily Student Transportation in Pune',
      description: 'School bus rental in Pune is widely used for daily student transportation by schools, colleges, coaching institutes, and activity centers. Hiring a dedicated school bus ensures punctual pickups and drops, route discipline, and consistent schedules that help students maintain routine and safety. These buses are designed to accommodate students comfortably with adequate seating, proper ventilation, and smooth suspension to reduce fatigue during daily travel. Schools benefit from centralized transport management, while parents gain confidence knowing their children travel together under supervised and professional transport arrangements.'
    },
    {
      title: 'School Picnic & Educational Trips',
      description: 'For school picnics and educational trips around Pune and nearby destinations, renting a school bus is the most practical and economical option. Group travel in a single bus keeps students organized, reduces logistical challenges, and ensures teachers can supervise easily. Spacious seating allows children to travel comfortably, while ample luggage space accommodates bags, food boxes, sports equipment, and learning materials. These trips become safer and more enjoyable when the entire group travels together without the risk of separation.'
    },
    {
      title: 'Local School Tours & City Visits',
      description: 'School buses on rent are ideal for local tours such as museum visits, science centers, zoos, historical places, and city learning programs. The controlled environment of a school bus ensures discipline, safety, and easy headcounts at every stop. Teachers can focus on educational engagement instead of transport coordination, making learning outings more productive and stress-free.'
    },
    {
      title: 'Outstation School Tours',
      description: 'For outstation school tours to hill stations, wildlife sanctuaries, heritage sites, and educational camps, school bus rentals provide dependable long-distance travel solutions. These buses are maintained for extended journeys and driven by experienced drivers who understand student safety, rest stops, and route planning. Long-distance comfort ensures students remain relaxed and energetic throughout the journey.'
    },
    {
      title: 'Sports Events & Competitions',
      description: 'Schools participating in inter-school sports events and competitions often require group transportation for students and staff. School buses provide sufficient space for sports kits, uniforms, and equipment, ensuring teams arrive together and on time. Group travel boosts team spirit and coordination while maintaining safety.'
    },
    {
      title: 'Cultural Programs & Inter-School Events',
      description: 'School buses are frequently hired for transporting students to cultural programs, competitions, exhibitions, and academic events. Coordinated group travel ensures timely arrivals, easy supervision, and safe return after events, reducing stress for organizers.'
    },
    {
      title: 'Safe & Controlled Travel Environment',
      description: 'A school bus offers a controlled travel environment specifically suited for children and teenagers. Structured seating, regulated entry and exit, and professional driving standards help maintain discipline and reduce travel risks.'
    },
    {
      title: 'Cost-Effective Group Transport',
      description: 'Hiring a single school bus for large groups is significantly more economical than arranging multiple vehicles. It reduces fuel costs, toll expenses, and administrative overhead while simplifying transport logistics for schools.'
    },
    {
      title: 'Parent & Institution Confidence',
      description: 'Parents and institutions trust school bus rentals because of their reliability, safety-focused design, and professional operations. Transparent pricing and dependable service enhance trust and long-term partnerships.'
    },
    {
      title: 'Flexible Scheduling for Schools',
      description: 'School bus rental services offer flexible scheduling options to suit academic calendars, exam periods, and event timelines, making them adaptable for varied institutional needs.'
    }
  ],

  services: [
    {
      name: 'School Bus on Rent in Pune',
      description: 'Sanavi Travels offers professional school bus rental services in Pune, tailored to meet the transportation needs of schools, colleges, and institutions. These buses are suitable for daily student travel, picnics, excursions, sports events, and educational tours. With experienced drivers, well-maintained vehicles, and safety-focused operations, schools can rely on consistent, secure, and organized student transportation.'
    },
    {
      name: 'AC School Bus Pune',
      description: 'AC school buses provide a comfortable and climate-controlled environment for students, especially during hot summer months. Air-conditioned travel helps maintain student comfort and focus, particularly during long journeys and outstation tours.'
    },
    {
      name: 'Non AC School Bus Pune',
      description: 'Non-AC school buses offer economical transport solutions while ensuring safety, seating comfort, and reliable performance for daily and occasional school travel.'
    },
    {
      name: '32 Seater School Bus Pune',
      description: '32 seater school buses are ideal for medium-sized student groups, offering balanced seating capacity and easy maneuverability for city and highway travel.'
    },
    {
      name: '35 Seater School Bus Hire Pune',
      description: '35 seater school buses accommodate larger student groups comfortably, making them suitable for picnics, competitions, and outstation school tours.'
    },
    {
      name: 'Mini Bus on Rent for School Pune',
      description: 'Mini school buses are perfect for smaller groups, activity clubs, and short-distance educational trips within Pune.'
    },
    {
      name: 'School Bus for Students Pune',
      description: 'Dedicated student transport services ensure structured seating, disciplined travel, and safe group movement under professional supervision.'
    },
    {
      name: 'School Bus for Family & Group Pune',
      description: 'School buses can also be used for mixed groups involving students, parents, and teachers during educational or recreational trips.'
    },
    {
      name: 'Affordable School Bus Rental Pune',
      description: 'Budget-friendly rental plans help schools manage transportation expenses without compromising on safety or service quality.'
    },
    {
      name: 'Best School Bus Service Pune',
      description: 'Recognized for punctuality, vehicle quality, and professional drivers, Sanavi Travels delivers dependable school bus services across Pune.'
    },
    {
      name: 'School Bus with Driver Pune',
      description: 'Experienced and licensed drivers ensure safe navigation, adherence to traffic rules, and responsible driving suitable for student travel.'
    },
    {
      name: 'School Bus for Picnic Pune',
      description: 'Ideal for school picnics, providing organized and enjoyable group travel experiences.'
    },
    {
      name: 'School Bus for Local Tour Pune',
      description: 'Suitable for local sightseeing, museum visits, and educational city tours.'
    },
    {
      name: 'Outstation School Bus Pune',
      description: 'Reliable outstation services support long-distance educational tours and camps.'
    }
  ],

  tableData: [
    ['AC School Bus', 'Non AC School Bus'],
    ['32 Seater', '35 Seater'],
    ['Daily Transport', 'Picnic Trips'],
    ['Local Tours', 'Outstation Tours'],
    ['Affordable Plans', 'Professional Drivers']
  ],

  whychoose: [
    {
      WhyChooseheading: 'Student Safety Priority',
      WhyChoosedescription: 'Safety-first approach with trained drivers, disciplined travel systems, and well-maintained buses.'
    },
    {
      WhyChooseheading: 'Experience in School Transport',
      WhyChoosedescription: 'Extensive experience handling student transportation requirements across Pune.'
    },
    {
      WhyChooseheading: 'Reliable & Punctual Service',
      WhyChoosedescription: 'On-time pickups and drops for stress-free school travel.'
    },
    {
      WhyChooseheading: 'Comfortable Seating',
      WhyChoosedescription: 'Spacious and ergonomic seating designed for student comfort.'
    },
    {
      WhyChooseheading: 'Transparent Pricing',
      WhyChoosedescription: 'Clear and honest pricing without hidden costs.'
    },
    {
      WhyChooseheading: 'Flexible Rental Options',
      WhyChoosedescription: 'Hourly, daily, and customized plans available.'
    },
    {
      WhyChooseheading: 'Professional Drivers',
      WhyChoosedescription: 'Licensed drivers trained for student safety and discipline.'
    },
    {
      WhyChooseheading: '24/7 Support',
      WhyChoosedescription: 'Continuous support for schools and parents.'
    }
  ]
};

const faqData = [
  {
    question: 'Do you provide school bus rental services in Pune?',
    answer: 'Yes, Sanavi Travels offers reliable school bus rental services in Pune for daily transport, picnics, and tours.'
  },
  {
    question: 'Are AC school buses available?',
    answer: 'Yes, both AC and Non-AC school buses are available.'
  },
  {
    question: 'Are drivers trained for student safety?',
    answer: 'Yes, drivers are experienced and trained to handle student transport responsibly.'
  },
  {
    question: 'Can buses be used for school picnics?',
    answer: 'Yes, school buses are ideal for picnics and educational trips.'
  },
  {
    question: 'Do you offer outstation school tours?',
    answer: 'Yes, we provide outstation school bus services.'
  },
  {
    question: 'Is the service affordable?',
    answer: 'Yes, we offer cost-effective plans for schools.'
  },
  {
    question: 'Are buses maintained regularly?',
    answer: 'Yes, all buses undergo regular maintenance and cleaning.'
  },
  {
    question: 'Can schools customize routes?',
    answer: 'Yes, routes and schedules can be customized.'
  },
  {
    question: 'Is advance booking required?',
    answer: 'Advance booking is recommended during peak seasons.'
  },
  {
    question: 'Is customer support available?',
    answer: 'Yes, 24/7 customer support is provided.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mrs. Anjali Kulkarni',
    feedback: 'Sanavi Travels provided excellent school bus service for our students. The bus was clean, the driver was responsible, and the entire trip was managed very professionally.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mr. Ramesh Patil',
    feedback: 'We hired a school bus from Sanavi Travels for a school picnic. The service was punctual, safe, and very well coordinated. Highly recommended.',
    rating: 5
  }
];








































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];








const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "School Bus on Rent in Pune - Sanavi Travels",
  "description": "Sanavi Travels provides school bus rental services in Pune with AC and Non-AC options. Choose from 32 seater, 35 seater, or mini buses for student transport, family trips, group travel, picnics, local tours, and outstation journeys with an experienced driver.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "4500+"
  }
};






  return (
    <div>

<Helmet>
  <title>
    Call : +91 7387507373 | School Bus on Rent in Pune | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Hire school bus in Pune with Sanavi Travels. AC, Non AC, 32 seater, 35 seater, and mini buses available for student transport, family trips, group outings, picnics, local tours, and outstation journeys with driver at affordable rates."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/309.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Schoolbusonrentinpune;